var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2568_18749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.25 39.8L31.3 3.89C30 1.29 27.5 0 25 0C22.5 0 20 1.3 18.7 3.89L0.750039 39.8C-1.58996 44.48 1.81004 50 7.05004 50H42.95C48.19 50 51.59 44.49 49.25 39.8ZM47.24 45.6C46.31 47.1 44.71 47.99 42.95 47.99H7.05004C5.29004 47.99 3.69004 47.1 2.76004 45.6C1.83004 44.1 1.75004 42.27 2.54004 40.69L20.49 4.79C21.36 3.04 23.05 2 25 2C26.95 2 28.64 3.04 29.51 4.79L47.46 40.7C48.25 42.28 48.16 44.11 47.24 45.61V45.6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 15H24C22.34 15 21 16.34 21 18V29C21 30.66 22.34 32 24 32H26C27.66 32 29 30.66 29 29V18C29 16.34 27.66 15 26 15ZM27 29C27 29.55 26.55 30 26 30H24C23.45 30 23 29.55 23 29V18C23 17.45 23.45 17 24 17H26C26.55 17 27 17.45 27 18V29Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 34H24C22.34 34 21 35.34 21 37V39C21 40.66 22.34 42 24 42H26C27.66 42 29 40.66 29 39V37C29 35.34 27.66 34 26 34ZM27 39C27 39.55 26.55 40 26 40H24C23.45 40 23 39.55 23 39V37C23 36.45 23.45 36 24 36H26C26.55 36 27 36.45 27 37V39Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2568_18749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.02,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/Attention.fd7ce6cd20821da66fa065637a4856f4.svg";
export { ForwardRef as ReactComponent };